import React from "react";
import "./FlowCards.css";
import offers from "./Media/Elite_Gold (1).png";
import win from "./Media/Elite Gold New.png";
import utilize from "./Media/5-DNHxHpO4.png";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

const flowData = [
  {
    imgSrc: offers,
    title: () => (
      <div>
        Explore <span className="text-pent">.gold</span>
      </div>
    ),
    description:
      ".Gold domains are redefining digital identity for the gold-based industry. From small jewelry retailers to global gold enterprises, everyone seeks their premium .gold domain. Explore and secure your perfect .gold domain today before others do.",
    buttonText: "Discover your perfect .gold domain",
    id: 1,
  },
  {
    imgSrc: win,
    title: () => (
      <div>
        <span className="text-pent">Own</span> it.
      </div>
    ),
    description:
      "A premium .gold domain can take your jewelry brand to new heights. Its uniqueness and recognition help you reach your ideal audience faster. Begin your digital journey with a curated .gold domain that is simple yet iconic. Own it and build your legacy.",
    buttonText: "Claim your exclusive .gold today",
    id: 2,
  },
  {
    imgSrc: utilize,
    title: () => (
      <div>
        <span className="text-pent">Grow</span> with it.
      </div>
    ),
    description:
      "Once you own your perfect .gold domain, it opens new opportunities in the digital market. Combine it with a strong website, marketing, and SEO to expand your reach. A .gold domain strengthens your presence and builds long-term value.",
    buttonText: "Expand your brand with .gold",
    id: 3,
  },
];

function FlowCards() {
  const isTablet = useMediaQuery({
    query: "(max-width: 1024px)",
  });

  return (
    <div>
      {!isTablet ? (
        <div className="unique-main">
          <ul className="unique-cards">
            {flowData.map((flow, index) => (
              <li
                className="unique-card"
                id={`unique-card-${flow.id}`}
                key={index}
              >
                <div className="unique-card-content">
                  <div className="unique-card-text">
                    <h2 className="heading !text-[64px]">{flow.title()}</h2>
                    <p>{flow.description}</p>
                    <Link to="/Marketplace">
                      <button className="white-btn !border-[#fae441]">
                        {flow.buttonText}
                      </button>
                    </Link>
                  </div>
                  <figure className="unique-card-figure">
                    <img
                      src={flow.imgSrc}
                      alt="card-one"
                      className="unique-card-img"
                    />
                  </figure>
                </div>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <div>
          {flowData.map((flow, index) => (
            <div
              className="unique-card-content-tablet mb-[40px] flex flex-col-reverse"
              key={index}
            >
              <div className="unique-card-text !w-full p-[24px]">
                <h2 className="heading !text-[64px]">{flow.title()}</h2>
                <p>{flow.description}</p>
                <Link to="/Marketplace">
                  <button className="white-btn !border-[#fae441]">
                    {flow.buttonText}
                  </button>
                </Link>
              </div>

              <img
                src={flow.imgSrc}
                alt="card-one"
                className="unique-card-img"
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default FlowCards;
